/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BillDetailAdditionalServiceVo } from './BillDetailAdditionalServiceVo';
import {
    BillDetailAdditionalServiceVoFromJSON,
    BillDetailAdditionalServiceVoFromJSONTyped,
    BillDetailAdditionalServiceVoToJSON,
    BillDetailAdditionalServiceVoToJSONTyped,
} from './BillDetailAdditionalServiceVo';

/**
 * 
 * @export
 * @interface ResponseListBillDetailAdditionalServiceVo
 */
export interface ResponseListBillDetailAdditionalServiceVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListBillDetailAdditionalServiceVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListBillDetailAdditionalServiceVo
     */
    message?: string;
    /**
     * 
     * @type {Array<BillDetailAdditionalServiceVo>}
     * @memberof ResponseListBillDetailAdditionalServiceVo
     */
    data?: Array<BillDetailAdditionalServiceVo>;
}

/**
 * Check if a given object implements the ResponseListBillDetailAdditionalServiceVo interface.
 */
export function instanceOfResponseListBillDetailAdditionalServiceVo(value: object): value is ResponseListBillDetailAdditionalServiceVo {
    return true;
}

export function ResponseListBillDetailAdditionalServiceVoFromJSON(json: any): ResponseListBillDetailAdditionalServiceVo {
    return ResponseListBillDetailAdditionalServiceVoFromJSONTyped(json, false);
}

export function ResponseListBillDetailAdditionalServiceVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListBillDetailAdditionalServiceVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(BillDetailAdditionalServiceVoFromJSON)),
    };
}

export function ResponseListBillDetailAdditionalServiceVoToJSON(json: any): ResponseListBillDetailAdditionalServiceVo {
    return ResponseListBillDetailAdditionalServiceVoToJSONTyped(json, false);
}

export function ResponseListBillDetailAdditionalServiceVoToJSONTyped(value?: ResponseListBillDetailAdditionalServiceVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(BillDetailAdditionalServiceVoToJSON)),
    };
}

